import { useQuery } from "@tanstack/react-query";
import type { ItemKind } from "@csf/shared";
import { api } from "./client.js";

// Поиск по каталогу ByMykel через наш /api/catalog/search.

export interface SkinCatalogItem {
  displayName: string;
  defIndex: number;
  paintIndex: number;
  minFloat: number;
  maxFloat: number;
  iconUrl: string | null;
  rarityColor: string | null;
}
export interface StickerCatalogItem {
  displayName: string;
  stickerId: string;
  iconUrl: string | null;
  rarityColor: string | null;
}
export interface KeychainCatalogItem {
  displayName: string;
  keychainId: number;
  iconUrl: string | null;
  rarityColor: string | null;
}

export type CatalogItem<K extends ItemKind = ItemKind> = K extends "skin"
  ? SkinCatalogItem
  : K extends "sticker"
    ? StickerCatalogItem
    : KeychainCatalogItem;

interface SearchResponse {
  kind: ItemKind;
  items: SkinCatalogItem[] | StickerCatalogItem[] | KeychainCatalogItem[];
}

export function useCatalogSearch<K extends ItemKind>(
  kind: K,
  query: string,
  enabled = true,
) {
  return useQuery({
    queryKey: ["catalog", kind, query],
    queryFn: () =>
      api<SearchResponse>("/api/catalog/search", {
        query: { kind, q: query, limit: 20 },
      }),
    enabled: enabled && query.trim().length >= 2,
    staleTime: 60 * 60 * 1000,
    select: (r) => r.items as Array<CatalogItem<K>>,
  });
}
